import { Line, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

export default {
  extends: Line,
  name: 'lineChart',
  mixins: [reactiveProp],
  data() {
    return {
      gradients: {},
      colors: [
        { color: '#E91E63', stop1: 'rgba(233, 30, 99, 0.9)', stop2: 'rgba(233, 30, 99, 0.25)', stop3: 'rgba(233, 30, 99, 0)' },
        { color: '#9C27B0', stop1: 'rgba(156, 39, 176, 0.9)', stop2: 'rgba(156, 39, 176, 0.25)', stop3: 'rgba(156, 39, 176, 0)' },
        { color: '#673AB7', stop1: 'rgba(103, 58, 183, 0.9)', stop2: 'rgba(103, 58, 183, 0.25)', stop3: 'rgba(103, 58, 183, 0)' },
        { color: '#3F51B5', stop1: 'rgba(63, 81, 181, 0.9)', stop2: 'rgba(63, 81, 181, 0.25)', stop3: 'rgba(63, 81, 181, 0)' },
        { color: '#2196F3', stop1: 'rgba(33, 150, 243, 0.9)', stop2: 'rgba(33, 150, 243, 0.25)', stop3: 'rgba(33, 150, 243, 0)' },
        { color: '#03A9F4', stop1: 'rgba(3, 169, 244, 0.9)', stop2: 'rgba(3, 169, 244, 0.25)', stop3: 'rgba(3, 169, 244, 0)' },
        { color: '#00BCD4', stop1: 'rgba(0, 188, 212, 0.9)', stop2: 'rgba(0, 188, 212, 0.25)', stop3: 'rgba(0, 188, 212, 0)' },
        { color: '#009688', stop1: 'rgba(0, 150, 136, 0.9)', stop2: 'rgba(0, 150, 136, 0.25)', stop3: 'rgba(0, 150, 136, 0)' },
        { color: '#4CAF50', stop1: 'rgba(76, 175, 80, 0.9)', stop2: 'rgba(76, 175, 80, 0.25)', stop3: 'rgba(76, 175, 80, 0)' },
        { color: '#8BC34A', stop1: 'rgba(139, 195, 74, 0.9)', stop2: 'rgba(139, 195, 74, 0.25)', stop3: 'rgba(139, 195, 74, 0)' },
        { color: '#FF9800', stop1: 'rgba(255, 152, 0, 0.9)', stop2: 'rgba(255, 152, 0, 0.25)', stop3: 'rgba(255, 152, 0, 0)' },
        { color: '#795548', stop1: 'rgba(121, 85, 72, 0.9)', stop2: 'rgba(121, 85, 72, 0.25)', stop3: 'rgba(121, 85, 72, 0)' },
      ]
    }
  },
  mounted() {
    this.fillData()
    this.formatDatasets()
  },
  methods: {
    fillData() {

      this.renderChart(this.chartData !== null ? {
        labels: this.chartData[0].labels,
        datasets: this.formatDatasets()
      } : null, { responsive: true, maintainAspectRatio: false, onClick:this.handle, scales: {
                  yAxes: [
                    {
                      stacked: false,
                      gridLines: {
                        display: true,
                        color: "rgba(255,99,132,0.2)"
                      },
                      ticks: {
                        suggestedMin: 0
                      }
                    }
                  ],
                  xAxes: [
                    {
                      gridLines: {
                        display: false
                      }
                    }
                  ]
                } 
      })
    },
    formatDatasets () {
      let datasets = Object.values(this.chartData).map(i => {
        this.gradients[`g${i.id}`] = this.$refs.canvas.getContext('2d').createLinearGradient(0, 0, 0, 450)
        this.gradients[`g${i.id}`].addColorStop(0, this.colors[i.id%12].stop1)
        this.gradients[`g${i.id}`].addColorStop(0.5, this.colors[i.id%12].stop2);
        this.gradients[`g${i.id}`].addColorStop(1, this.colors[i.id%12].stop3);
        
        return {
          label: i.label1,
          borderColor: this.colors[i.id%12].color,
          pointBackgroundColor: 'white',
          borderWidth: 1,
          pointBorderColor: this.colors[i.id%12].color,
          backgroundColor: this.gradients[`g${i.id}`],
          data: i.data1
        }

      })
      return datasets
    },
    handle (point, event) {
      const item = event[0]
      // console.log(point);
      // console.log(event);
      // console.log(item);
    }
  }
}